module.exports = __webpack_public_path__ + "static/media/noEmailInsightsReport.429a16c0.png";